import React from "react";
import { Stack } from "@mui/material";
import UploadFileIcon from "@mui/icons-material/UploadFile";
import ButtonMAS from "ButtonMAS/ButtonMAS";
import s from "../MerchantDocumentUpload.module.scss";

const ActionsCell = ({
  rowId,
  draggingCategory,
  merchantId,
  uploadingKey,
  fileInputRefs,
  acceptAttr,
  uploadLabel,
  onDragOver,
  onDragLeave,
  onDrop,
  onRequestUpload,
}) => (
  <Stack
    direction="row"
    alignItems="center"
    className={[
      s.actionsCell,
      draggingCategory === rowId ? s.actionsCellDragOver : "",
    ].join(" ")}
    onDragEnter={(event) => onDragOver(event, rowId)}
    onDragOver={(event) => onDragOver(event, rowId)}
    onDragLeave={onDragLeave}
    onDrop={(event) => onDrop(event, rowId)}
  >
    <input
      ref={(node) => {
        if (node) {
          fileInputRefs.current[rowId] = node;
        }
      }}
      type="file"
      accept={acceptAttr}
      multiple
      className={s.hiddenInput}
      onChange={(event) =>
        merchantId ? onRequestUpload(rowId, event.target.files) : undefined
      }
      disabled={!merchantId}
    />
    <ButtonMAS
      type="button"
      size="small"
      className={s.uploadBtn}
      startIcon={<UploadFileIcon />}
      onClick={() => fileInputRefs.current[rowId]?.click()}
      isLoading={uploadingKey === rowId}
      disabled={!merchantId || uploadingKey === rowId}
    >
      {uploadLabel}
    </ButtonMAS>
  </Stack>
);

export default ActionsCell;
